import axios from 'axios';
import '@/axios';
import { createApp } from 'vue';
import store from '@/store';
import App from '@/App.vue';
import router from '@/router';
import { createMetaManager, plugin as metaPlugin } from 'vue-meta';
import { FontAwesomeIcon } from '@/assets/plugins/font-awesome';
import VueTippy from 'vue-tippy';
import { createVfm } from 'vue-final-modal';
import { basicSetup as basicSetupCodemirror } from 'codemirror';
import { html } from '@codemirror/lang-html';
import { css } from '@codemirror/lang-css';
import { javascript } from '@codemirror/lang-javascript';
import VueCodemirror from 'vue-codemirror';
import Toast, { useToast } from "vue-toastification";
import app_mixin from "@/mixin";
import lib from '@/lib';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'tippy.js/dist/tippy.css';
//import 'tippy.js/themes/material.css';
import 'vue-final-modal/style.css';
import "vue-toastification/dist/index.css";
import '@/main.scss';

const app = createApp(App);
const metaManager = createMetaManager();
const vfm = createVfm();
const toast = useToast();

window['appInstance'] = null;
window['appComponent'] = null;
window['storeInstance'] = null;

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$store = store;
app.use(VueTippy, {
	directive: 'tippy', // => v-tippy
	component: 'tippy', // => <tippy/>
	componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
	defaultProps: {
		placement: 'auto-end',
		allowHTML: true,
		theme: 'material',
		maxWidth: 400,
		arrow: true,
		delay: [0, 0], //[200, 0],
		duration: 0,
		//appendTo: 'parent',
    },
	content: (reference) => reference.getAttribute('title') || reference.getAttribute('content'),
});
app.use(VueCodemirror, {
	autofocus: true,
	disabled: false,
	indentWithTab: true,
	tabSize: 4,
	placeholder: 'Code goes here...',
	extensions: [basicSetupCodemirror, html(), css(), javascript()],
	// ...
})
app.use(Toast, {
	position: "bottom-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnHover: true,
});
app.config.globalProperties.$toast = toast; 
//app.config.productionTip = false;
//app.config.debug = true;
//app.config.devtools = true;
app.use(router);
app.use(store);
app.use(store.state.app.i18n);
app.use(metaManager);
app.use(vfm);
app.component('font-awesome-icon', FontAwesomeIcon);
lib.addMixin(app_mixin);
app.mount('#app');

window['lib'] = lib;
window['axios'] = axios;

window['appInstance'] = app;
window['storeInstance'] = store;
